import { MainLayout } from "../layouts";
import {
  Settings,
  Forbidden,
} from "../pages";
import SettingsIcon from "../assets/images/sidebar/support.svg";
import { renderRoutes } from "./generate-routes";
import { Role } from "../utils/enum";
import { ActivateActivity, CreateConfig, UpdateConfig, UpdatePtz, UpdateZone } from "../pages/settings/tabs";



interface Route {
  name: string;
  title: string;
  element: React.ReactElement;
  path: string;
  icon?: React.ReactNode;
  roles?: string[];
  routes?: Route[];
}

interface Layout {
  layout: React.ComponentType<any>;
  isPublic: boolean;
  routes: Route[];
}

export const routes: Layout[] = [
  
  {
    layout: MainLayout,
    isPublic: false,
    routes: [
      {
        name: "setting",
        title: "Settings",
        element: <Settings />,
        path: "/settings",
        icon: SettingsIcon,
        roles: [Role.ADMIN, Role.IMAGE_CAPTAIN, Role.IMAGE_QUALITY_CONTROLLER, Role.STREAMING_CAPTAIN, Role.STREAMING_QUALITY_CONTROLLER, Role.VIDEO_CAPTAIN, Role.VIDEO_QUALITY_CONTROLLER],
        routes:[
          {
            name:'update-config',
            title:'Update Config',
            element: <UpdateConfig/>,
            path: "/settings/config/update-config/:uin_id",
          },
          {
            name:'update-zone',
            title:'Update Zone',
            element: <UpdateZone/>,
            path: "/settings/config/update-zone/:uin_id",
          },
          {
            name:'update-ptz',
            title:'Update PTZ',
            element: <UpdatePtz/>,
            path: "/settings/config/update-ptz/:uin_id",
          },
          {
            name:'update-activities',
            title:'Update Activities',
            element: <ActivateActivity/>,
            path: "/settings/config/activate-activity/:uin_id",
          }
        ],
      },
      {
        name: "forbidden",
        title: "403 Forbidden",
        element: <Forbidden />,
        path: "/403", // Add this route for forbidden access
      },
    ],
  },
];

export const renderSidebars = (targetNames: string[]): Route[] => {
  const mainLayout = routes.find((layout) => layout.layout === MainLayout);
  const mainRoutes = mainLayout?.routes || [];
  return mainRoutes.filter((route) => targetNames.includes(route.name));
};

// Generate routes
export const Routes = renderRoutes(routes);